import { Component, inject } from "@angular/core";
import { BrandingService } from "./branding.service";

@Component({
    selector: "current-organization-logo",
    template: `
        <div
            *ngIf="service.currentOrganizationLogoUrl()"
            class="organization-logo-container"
            [style.backgroundImage]="'url(' + service.currentOrganizationLogoUrl() + ')'"></div>
    `,
    styleUrls: ["./current-organization-logo.component.scss"]
})
export class CurrentOrganizationLogoComponent {
    protected readonly service = inject(BrandingService);
}
